module.exports = __webpack_public_path__ + "68b54e1187d71d82cd91477d20af8dfb.mp4";